import $ from 'jquery'
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import RecapDMP from '@/views/dossierMedical/dossier-medical/recap-dmp';
import EditDMP from '@/views/dossierMedical/dossier-medical/edit-dmp';

export default {
    name: 'dossier-medical',
    components: {
        RecapDMP, EditDMP
    },
    props: {
        patientId: Number,
        consultation: Object
    },
    data() {
        return {
            is_dmp_edit: false,
            type_dmp: '',

            is_consultation: '',
            l_loading: true,

            // -----------------------------------
            vm_state: open_menu_state,
            v: 0,
            info_dmp: {},
            type_consultation_id: 0
        }
    },
    computed: {
        
    },
    mounted() {
        let t = this;
        $(document).bind("click", function (e) {
            let $clicked = $(e.target);
            if (!$clicked.parents().hasClass("option-container")) {
                if (t.v != 0) {
                    t.openMenu(t.v, 'option-box', 'animate-fadeInRight', 'animate-fadeOutRight')
                }
            }
        });
    },
    
    methods: {
        refreshView(edit_info) {
            this.is_dmp_edit = edit_info.is_edit
            this.type_dmp = edit_info.type_dmp
            this.info_dmp = edit_info.info_dmp
        },

        /**
         * Open Menu Dropdown
         */
        openMenu: function (state, selector, show_in, show_out) {
            this.v = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.v = closeMenu.wrapMenu(selector, show_in, show_out)
        },
    }
}